import React, { useContext } from "react";
import { Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context";
import StoreProfileForm from "../components/StoreProfileForm";

export default function StoreProfile() {
  const navigate = useNavigate();
  const { currentUser } = useContext(AppContext) || {};

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/store");
    }
  };

  const renderHeader = () => (
    <div className="d-flex align-items-center mb-4">
      <button
        type="button"
        aria-label="Back"
        className="btn btn-light rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow-sm"
        style={{ width: 36, height: 36 }}
        onClick={handleBack}
      >
        <i className="fa-solid fa-arrow-left" />
      </button>
      <div>
        <h1 className="h4 mb-0">Profile</h1>
        <div className="text-muted small">
          Manage your account and billing details
        </div>
      </div>
    </div>
  );

  if (!currentUser?.id) {
    return (
      <Container className="py-4" style={{ maxWidth: 720 }}>
        {renderHeader()}
        <div className="alert alert-warning mb-0" role="alert">
          Please sign in to edit your profile.
        </div>
      </Container>
    );
  }

  if (currentUser?.dealer || currentUser?.admin) {
    return (
      <Container className="py-4" style={{ maxWidth: 720 }}>
        {renderHeader()}
        <div className="alert alert-info mb-0" role="alert">
          Profile editing is available for buyer accounts only.
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-4" style={{ maxWidth: 720 }}>
      {renderHeader()}
      <StoreProfileForm layout="page" />
    </Container>
  );
}
